// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import AuthService from './auth'
import AuthPlugin from './plugins/auth'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMaterial from 'vue-material'
import VueMaterialSlider from 'vue-material-slider'
import VueTour from 'vue-tour'

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css' // This line here
import 'vue-material-slider/dist/lib/vue-material-slider.css'
require('vue-tour/dist/vue-tour.css')
//  import './assets/theme.scss'

Vue.use(VueMaterial)
Vue.use(VueAxios, axios)
Vue.use(VueMaterialSlider)
Vue.use(AuthService)
Vue.use(AuthPlugin)
Vue.use(VueTour)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data: {
    loading: 0
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js